0<template>
    <b-row>
        <b-col cols="9" md="11">
            <Datetime
                type="datetime"
                input-class="form-control"
                v-model="content" 
                :value-zone="zoneValue"
                :zone="zoneValue"
                :use12-hour="customData.datetime.is12h"
                :hour-step="customData.datetime.hourStep"
                :minute-step="customData.datetime.minuteStep"
                :format="customData.datetime.format"
                :unavailableTime="unavailableTime"
                :availableHours="availableHours"
                :min-datetime="minDate"
                :max-datetime="maxDate"
                auto
                v-bind="$attrs"
                @onChangeDate="onChangeDate"
            />

         <b-form-invalid-feedback :id="field.key" style="display:block">
          {{ errors[0] || null }}
        </b-form-invalid-feedback>
        </b-col>

        <b-col cols="3" md="1">
            <b-button variant="danger" @click="resetValue" > <b-icon icon="x" /> </b-button>
        </b-col>
    </b-row>
</template>

<style scoped>
.theme-orange .vdatetime-popup__header,
.theme-orange .vdatetime-calendar__month__day--selected > span > span,
.theme-orange .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #FF9800;
}

.theme-orange .vdatetime-year-picker__item--selected,
.theme-orange .vdatetime-time-picker__item--selected,
.theme-orange .vdatetime-popup__actions__button {
  color: #ff9800;
}
</style>

<script>
import Datetime from '@/components/vue-datetime/src/Datetime'
import moment from 'moment'
import { isEmpty } from 'lodash'
import { buildFiltersFromContext } from '../../utils/context'

export default {
    name: "IdentityField_DateTime",
    components: {
        Datetime
    },
    props: {
        field: {
            type: Object
        },
        value: {
            type: Date | String
        },
        store: {
            type: Object,
            default: null
        },
        context: {
            type: Object,
            default: function() {
                return {}
            }
        },
        translator: {
            type: Function
        }
    },
    data: function() {
        return {
            errors: [],
            unavailableTime: [],
        }
    },
    watch: {
        content(val) {
            this.check(val)
        }
    },
    computed: {
        content: {
            get() {
                if (this.value == '') {
                    return null
                }  

                return this.value;
            },

            set(val) {
                this.check(val)
                this.$emit('input', val);
            }
        },

        customData() {
            const def = {
                datetime: {
                    is12h: false,
                    hourStep: 1,
                    minuteStep: 1,
                    format: "yyyy-MM-dd HH:mm",
                    availableTime: null,
                    disablePastDates: false,
                    from: null,
                    to: null,
                }
            }

            console.log("customData", this.field.constraints.custom_data)

            if (isEmpty(this.field.constraints.custom_data)) {
                return def
            }

            return this.field.constraints.custom_data || def
        },

        availableHours() {
            let aTime = this.customData.datetime.availableHours;
            if (aTime) {
                return aTime.split("-")
            }

            return []
        },

        zoneValue() {
            if (this.store !== null) {
                return this.store.getters.getUserTimezone || null
            }
            

            return null
        },

        minDate() {
            const { from } = this.customData.datetime
            if (from) {
                return moment(from).format()
            }

            if (this.customData.datetime.disablePastDates) {
                return moment().format()
            }

            return null
        },
        
        maxDate() {
            const { to } = this.customData.datetime
            if (to) {
                return moment(to).format()
            }

            return null
        }
    },
    methods: {
        check(val) {
            this.errors = []

            if (this.field.constraints.required) {
                if (val == "") {
                    this.errors.push(this.translator("identityField.requiredField"))
                }
            }
            
            this.$emit("error", {field: this.field.key, error: this.errors.length > 0})
        },

        onChangeDate(date) {
            if (this.store !== null) {
                let componentUuid = this.store.getters.currentComponent.uuid
                let filters = buildFiltersFromContext(this.field.context, this.context)

                this.store.dispatch("field_DateTime_unavailableTime", {
                    uuid: componentUuid,
                    context: {
                        dateFrom: date.toFormat("yyyy-MM-dd") + " 00:00:00",
                        dateTo: date.toFormat("yyyy-MM-dd") + " 23:59:59",
                        dateField: this.field.key,
                        ...filters
                    }
                }).then(resp => {
                    let items = resp.items

                    this.unavailableTime = items.map(i => {
                        return i[this.field.key]
                    })
                })
            }
        },

        resetValue() {
            this.content = null
        }
    },
    
    mounted() {
        this.check(this.content)
    }
}
</script>